import Shepherd from 'shepherd.js'

import ApplicationController from "./application_controller";

export default class extends ApplicationController {

    connect() {
        if (!localStorage.getItem('inrivacareerportal-tour')) {
            this.showTour();
        }
    }

    showTour()  {
        const tour = new Shepherd.Tour({
            useModalOverlay: true,
            defaultStepOptions: {
                classes: 'shadow-md bg-blue-100',
                scrollTo: true,
                cancelIcon: {
                    enabled: true
                }
            },
            popperOptions: {
                modifiers: [{ name: 'offset', options: { offset: [0, 12] } }]
            }
        });

        tour.on('complete', this.dismissTour)
        tour.on('hide', this.dismissTour)

        tour.addStep({
            id: 'dashboard-greeting',
            title: "Willkommen im Karrierportal!",
            text: "Lassen Sie uns Ihnen eine kurze Tour durch Ihr neues Dashboard zeigen.",
            attachTo: {
                element: '.dashboard-greeting',
                on: 'bottom'
            },
            buttons: [
                {
                    text: "Weiter",
                    action: tour.next
                },
                {
                    text: "Abbrechen",
                    action: tour.cancel,
                    classes: 'shepherd-button-secondary',
                },
                {   text: "Schließen",
                    action: function () {
                        tour.complete();
                        return this.hide();
                    },
                    classes: 'shepherd-button-secondary',
                }
            ]
        })

        tour.addStep({
            id: 'dashboard-charts',
            text: "Hier sehen Sie wichtige Kennzahlen und Statistiken auf einen Blick.",
            attachTo: {
                element: '.dashboard-charts',
                on: 'bottom'
            },
            buttons: [
                {
                    text: "Zurück",
                    action: tour.back,
                    classes: 'shepherd-button-secondary'
                },
                {
                    text: "Weiter",
                    action: tour.next
                },
                {
                    text: "Später",
                    action: tour.cancel,
                    classes: 'shepherd-button-secondary'
                }
            ]
            })

        tour.addStep({
            id: 'dashboard-actions',
            text: "Von hier aus können Sie schnell auf die wichtigsten Funktionen zugreifen.",
            attachTo: {
                element: '.dashboard-actions',
                on: 'bottom'
            },
            buttons: [
                {
                    text: "Zurück",
                    action: tour.back,
                    classes: 'shepherd-button-secondary'
                },
                {
                    text: "Weiter",
                    action: tour.next
                },
                {
                    text: "Später",
                    action: tour.cancel,
                    classes: 'shepherd-button-secondary'
                }
            ]
        })

            tour.addStep({
                id: 'dashboard-pools',
                text: "Hier verwalten Sie Ihre Bewerberpools und Kategorien.",
                attachTo: {
                    element: '.dashboard-pools',
                    on: 'bottom'
                },
                buttons: [
                    {
                        text: "Zurück",
                        action: tour.back,
                        classes: 'shepherd-button-secondary'
                    },
                    {
                        text: "Weiter",
                        action: tour.next
                    },
                    {
                        text: "Später",
                        action: tour.cancel,
                        classes: 'shepherd-button-secondary'
                    }
                ]
            })

        tour.addStep({
            id: 'dashboard-gdpr',
            text: "Hier finden Sie alle GDPR-relevanten Funktionen und Einstellungen.",
            attachTo: {
                element: '.dashboard-gdpr',
                on: 'bottom'
            },
            buttons: [
                {
                    text: "Zurück",
                    action: tour.back,
                    classes: 'shepherd-button-secondary'
                },
                {
                    text: "Weiter",
                    action: tour.next
                },
                {
                    text: "Später",
                    action: tour.cancel,
                    classes: 'shepherd-button-secondary'
                }
            ]
        })

        tour.addStep({
            id: 'dashboard-tasks',
            text: "Ihre aktuellen Aufgaben und To-Dos finden Sie hier.",
            attachTo: {
                element: '.dashboard-tasks',
                on: 'bottom'
            },
            buttons: [
                {
                    text: "Zurück",
                    action: tour.back,
                    classes: 'shepherd-button-secondary'
                },
                {
                    text: "Weiter",
                    action: tour.next
                },
                {
                    text: "Später",
                    action: tour.cancel,
                    classes: 'shepherd-button-secondary'
                }
            ]
        })

        tour.addStep({
            id: 'dashboard-team',
            text: "Hier sehen Sie Ihr Team und die wichtigsten Kontakte.",
            attachTo: {
                element: '.dashboard-team',
                on: 'bottom'
            },
            buttons: [
                {
                    text: "Zurück",
                    action: tour.back,
                    classes: 'shepherd-button-secondary'
                },
                {
                    text: "Weiter",
                    action: tour.next
                },
                {
                    text: "Später",
                    action: tour.cancel,
                    classes: 'shepherd-button-secondary'
                }
            ]
        })

        tour.addStep({
            id: 'dashboard-activities',
            text: "Alle Aktivitäten und Updates werden hier chronologisch angezeigt.",
            attachTo: {
                element: '.dashboard-activities',
                on: 'bottom'
            },
            buttons: [
                {
                    text: "Zurück",
                    action: tour.back,
                    classes: 'shepherd-button-secondary'
                },
                {
                    text: "Weiter",
                    action: tour.next
                },

                {
                    text: "Später",
                    action: tour.cancel,
                    classes: 'shepherd-button-secondary'
                }
            ]
        })

        tour.addStep({
            id: 'dashboard-finished',
            title: "Tour abgeschlossen!",
            text: "Sie kennen sich jetzt mit dem Dashboard aus. Viel Erfolg bei der Nutzung!",
            buttons: [
                {
                    text: "Zurück",
                    action: tour.back,
                    classes: 'shepherd-button-secondary'
                },
                {
                    action: function () {
                        tour.complete();
                        return this.hide();
                    },
                    text: "Fertig"
                }
            ]
        })

        tour.start();
    }

    dismissTour() {
        if(!localStorage.getItem('inrivacareerportal-tour')) {
            localStorage.setItem('inrivacareerportal-tour', 'yes');
        }
    }


}
